import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class JobDescriptionsValidationUtils {

    static getNonWhitespaceLength(value: string | null | undefined): number {
        if (!value) return 0;
        return value.replace(/\s/g, '').length;
    }

    static jobDescriptionValidator(): ValidatorFn {

        return (control: AbstractControl): ValidationErrors | null => {

            if (!control.value) {
                return null;
            }

            const nonWhitespaceLength = this.getNonWhitespaceLength(control.value);

            if (nonWhitespaceLength < 50) {
                return { minlength: { requiredLength: 50, actualLength: nonWhitespaceLength } };
            }

            if (nonWhitespaceLength > 5000) {
                return { maxlength: { requiredLength: 5000, actualLength: nonWhitespaceLength } };
            }

            return null;
        };
    }

    static getJobDescriptionError(
        control: AbstractControl | null
    ): string {

        if (!control || !control.errors || !control.touched) {
            return '';
        }

        if (control.errors['required']) {
            return 'Job Description is required.';
        }

        if (control.errors['minlength']) {
            return 'Job Description must contain at least 50 characters (excluding whitespace).';
        }

        if (control.errors['maxlength']) {
            return 'Job Description cannot exceed 5000 characters (excluding whitespace).';
        }

        return '';
    }
}